// @flow
import React, { Fragment } from 'react';

import { t } from 'Src/i18n';
import { Title } from 'Components/frameworks/title/Title.jsx';
import { ICONS } from 'Components/utils/icon/icons';
import { COLORS } from 'Components/utils/color/colors';

import FormSelect from 'Components/frameworks/form-select/FormSelect.jsx';
import FormInputText from 'Components/frameworks/form-input-text/FormInputText.jsx';
import { type ResolvedProps } from 'Client/cms/toolkit/cruise-booking/cruiseBooking.resolver';

type Props = {
  ...$Exact<ResolvedProps>,
  transport: string,
  onChange: (*) => void,
};

export const CruiseCriteriaFieldset = ({
  bookingCriteria,
  cruise,
  product,
  transport,
  onChange,
}: Props) => {
  const transports = bookingCriteria.departureCities || [];

  return (
    <Fragment>
      <div className="w-full sm:w-1/3 p-2" data-testid="cruiseBookingForm-cruiseDates">
        <Title
          className="my-2"
          color={COLORS.GRAY_DARKER}
          hLevel={3}
          iconName={ICONS.DATE}
          theme="title-sans-3"
        >
          {t('criteria.dateLabel')}
        </Title>
        <FormInputText isReadOnly placeholder={product.dateRange || ''} />
      </div>
      <div className="w-full sm:w-1/3 p-2" data-testid="cruiseBookingForm-cruiseLocation">
        <Title
          className="my-2"
          color={COLORS.GRAY_DARKER}
          hLevel={3}
          iconName={ICONS.ADDRESS}
          theme="title-sans-3"
        >
          {t('criteria.fromToLabel')}
        </Title>
        <FormInputText isReadOnly placeholder={cruise.fromToDestination || ''} />
      </div>
      <div className="w-full sm:w-1/3 p-2" data-testid="cruiseBookingForm-cruiseDuration">
        <Title
          className="my-2"
          color={COLORS.GRAY_DARKER}
          hLevel={3}
          iconName={ICONS.DURATION}
          theme="title-sans-3"
        >
          {t('criteria.durationLabel')}
        </Title>
        <FormInputText isReadOnly placeholder={product.duration || ''} />
      </div>
      {transports.length && (
        <div className="w-full sm:w-1/3 p-2" data-testid="cruiseBookingForm-transports">
          <Title
            className="my-2"
            color={COLORS.GRAY_DARKER}
            hLevel={3}
            iconName={ICONS.TRANSPORT}
            theme="title-sans-3"
          >
            {t('criteria.transportationLabel')}
          </Title>
          <FormSelect
            options={transports}
            dataSelector="cruiseBookingForm-transports-formSelect"
            value={transport}
            onChange={onChange}
          />
        </div>
      )}
    </Fragment>
  );
};
